import { DotsMultiline, IDotsMultilineProps } from "dots-ui/dotsMultiline";
import { useMemo } from "react";
import { getValueTooltip } from "../../../../utils";

export function AvisMultiline<T = object>(
  props: Readonly<IDotsMultilineProps<T>>,
) {
  const tooltipValue = useMemo(() => {
    return getValueTooltip(undefined, props.bag, props.bagField);
  }, [props.bag, props.bagField]);

  return (
    <div title={tooltipValue}>
      <DotsMultiline<T> spacing="small" {...props} />
    </div>
  );
}
